<template>
  <div class="block-content border-bottom border-top py-3 mt-2">
    <b-row>
      <b-col cols="12">
        <div
          v-if="summaryText && summaryText !== ''"
          class="text-profile-highlight highlight-block"
          v-html="summaryText"
        />

        <div
          v-else
          class="text-profile-highlight"
        >
          <span>No Profile Highlight</span>
        </div>

        <expert-result-summary-update-button
          :expert-id="expertId"
          :expert="expert"
          :bio-description-source="bioHighlight"
          :project-description="cleanedProjectDescription"
          :project-title="projectTitle"
          :summary="summaryText"
          :action="'edit'"
          :assignment-id="assignmentId"
          @update-summary="summaryUpdated"
        />
      </b-col>
      <b-col>
        <multiselect
          id="ajax"
          :custom-label="customLabel"
          :show-labels="false"
          track-by="project_id"
          placeholder="Existing Project Highlights"
          open-direction="bottom"
          :options-limit="300"
          :max-height="600"
          :clear-on-select="false"
          :close-on-select="true"
          :options="summaryList"
          :searchable="true"
          :loading="isLoading"
          :internal-search="true"
          :show-no-results="true"
          @select="selectHighlight"
          @open="searchProject"
        >
          <template
            slot="tag"
            slot-scope="{ option }"
          >
            <span class="custom__tag"><span>{{
              option.project
            }}</span></span>
          </template>

          <span slot="noResult">No project with highlight existed</span>
          <span slot="noOptions">No project with highlight existed</span>
        </multiselect>

        <b-form-checkbox
          v-if="bioHighlight != null"
          v-model="useBioChecked"
          class="mt-1"
          switch
          inline
        >
          Use LinkedIn Bio
        </b-form-checkbox>

        <b-form-checkbox
          v-if="expert.expert_bio.main_summary !== null"
          v-model="useMainHighlightChecked"
          class="mt-1"
          switch
          inline
        >
          Use Main Highlight
        </b-form-checkbox>
      </b-col>
      <b-col>
        <div v-if="selectedSummary != null">
          <div
            class="mb-1"
            v-html="selectedSummary"
          />
          <div>
            <b-button
              size="sm"
              @click="setExpertSummary"
            >
              <b-spinner
                v-if="isUpdating"
                small
                variant="success"
                type="grow"
                label="Spinning"
              />
              Set this highlight
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    name: 'ResultSummaryBlock',
    components: {Multiselect},
    props: {
        expert: {type: Object, required: true},
        projectTitle: {type: String, default: ''},
        projectDescription: {type: String, default: ''},
        summary: {type: String, default: ''},
        bioHighlight: {type: String, default: ''},
        assignmentId: {type: Number, required: true},
        projectId: {type: Number, required: true},
        expertId: {type: Number, required: true},
    },
    data: function () {
        return {
            summaryText: this.summary,
            selectedSummary: null,
            expertSummary: null,
            isLoading: false,
            isUpdating: false,
            summaryList: [],
            useBioChecked: false,
            useMainHighlightChecked: false,
            cleanedProjectDescription: null,
        }
    },
    watch: {
        summary: {
            immediate: true,
            handler() {
                this.summaryText = this.summary
            }
        },
        useBioChecked: function () {
            if (this.useBioChecked) {
                this.selectedSummary = this.bioHighlight
            } else {
                this.selectedSummary = this.expertSummary
            }
        },
        useMainHighlightChecked: function (checkValue) {
            if (checkValue) {
                this.selectedSummary = this.expert.expert_bio.main_summary
            } else {
                this.selectedSummary = this.expertSummary
            }
        },
        projectDescription: {
            immediate: true,
            handler() {
                this.cleanedProjectDescription = this.projectDescription.replace(/<[^>]*>/g, '')
            }
        }
    },
    methods: {
        selectHighlight(value) {
            this.selectedSummary = value.expert_summary
            this.expertSummary = value.expert_summary

            this.resetCheckboxes()
        },
        summaryUpdated(value) {
            this.$store.commit('expert/updateExpertSummary', {
                projectId: this.projectId,
                expertId: this.expertId,
                assignmentId: this.assignmentId,
                expert_summary: value
            })

            this.resetCheckboxes()
            this.selectedSummary = null
        },
        setExpertSummary() {
            const summary = this.selectedSummary

            this.isUpdating = true
            axios.patch(`/api/v2/assignments/${this.assignmentId}`,
                {
                    data: {
                        type: 'assignments',
                        id: this.assignmentId.toString(),
                        attributes: {
                            expert_summary: summary,
                        },
                    },
                },
                {
                    headers: {
                        'Content-Type': 'application/vnd.api+json',
                    },
                }).then(res => {
                this.summaryUpdated(summary)
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                this.isUpdating = false
            })
        },
        searchProject(query) {
            this.isLoading = true
            axios.get(`/admin/experts/api/summaries/${this.expertId}?current-project=${this.projectId}&query=${query}`).then(response => {
                this.summaryList = response.data.data
                this.isLoading = false
            })
        },
        customLabel({project}) {
            return project.project_title
        },
        resetCheckboxes() {
            this.useBioChecked = false
            this.useMainHighlightChecked = false
        }
    },
}
</script>

<style scoped>
.text-profile-highlight {
    display: inline;
}
</style>
